"use client";

import { createContext, useContext, useMemo, type ReactNode } from "react";
import { useAuthUser, type AuthContextType } from "@/hooks/useAuthUser";
import { getAuthDerivedState } from "@/lib/auth/auth.selectors";

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
}

export function AuthProvider({ children }: { children: ReactNode }) {
  const auth = useAuthUser();
  const value = useMemo<AuthContextType>(
    () => ({
      ...auth,
      ...getAuthDerivedState(auth.user),
    }),
    [auth]
  );
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}